import React from 'react'
import MessageUI from '../../../widgets/output/MessageUI'
import ModalFormUI from '../../../widgets/form/ModalFormUI'

const UserDeleteModalUI = ({context, successMsg, errorList, setErrorList,
    // modes
    deleteMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Delete user'
    buttonLabel='Yes delete'
    cancelLabel='Cancel delete'

    isOpen={deleteMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <MessageUI label='Are you sure you want to delete selected user?' />
  </ModalFormUI>

export default UserDeleteModalUI
